import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  size?: number;
};
const TwitterIcon: FC<Props> = ({ size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill={colors['--pink-500']}
      d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.767 9.046c.008.125.008.257.008.385 0 3.932-2.995 8.462-8.467 8.462a8.437 8.437 0 01-4.57-1.334c.241.027.472.037.718.037a5.968 5.968 0 003.694-1.27 2.976 2.976 0 01-2.78-2.062c.458.067.87.067 1.342-.053a2.973 2.973 0 01-2.382-2.92v-.037c.394.222.857.359 1.342.377a2.977 2.977 0 01-.921-3.975 8.445 8.445 0 006.134 3.11c-.42-2.022 1.09-3.659 2.906-3.659a2.97 2.97 0 012.172.938 5.877 5.877 0 001.889-.716 2.96 2.96 0 01-1.307 1.637c.6-.064 1.178-.23 1.714-.463a6.235 6.235 0 01-1.492 1.543z"
    />
  </svg>
);

export default TwitterIcon;
